import { FormattedMessage } from "react-intl";
import ContentBulkUploadIcon from "../../../components/Common/SvgIcons/ManageIcons/ContentBulkUploadIcon";
import DailyDigestIcon from "../../../components/Common/SvgIcons/ManageIcons/DailyDigestIcon";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import QuestionBankIcon from "../../../components/Common/SvgIcons/ManageIcons/QuestionBankIcon";
import QuestionsAndChoicesIcon from "../../../components/Common/SvgIcons/ManageIcons/QuestionsAndChoicesIcon";
import QuizImagesIcon from "../../../components/Common/SvgIcons/ManageIcons/QuizImagesIcon";
import { colors } from "../../stripeColors";
import ShotClass from "../../../assets/downloads/ShotClass.csv";
import Questionaire from "../../../assets/downloads/Questionaire.csv";
import ShotclassesQuestionBank from "../../../assets/downloads/ShotclassesQuestionBank.csv";
import ShotclassesDailyDigest from "../../../assets/downloads/ShotclassesDailyDigest.csv";

export const contentBulkUpload = {
  label: "Content Bulk Upload",
  path: (tenantName) => `/${tenantName}/manage/contentBulkUpload`,
  icon: ContentBulkUploadIcon,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="MANAGE_SHOTCLASSES" />,
      path: `/${tenantName}/manage`,
      onClick: () => navigate(`/${tenantName}/manage`),
    },
    {
      key: 2,
      label: <FormattedMessage id="BULK_UPLOAD" />,
      path: `${contentBulkUpload.path(tenantName)}`,
      //onClick: () => navigate(`${contentBulkUpload.path(tenantName)}`),
    },
  ],
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="BULKUPLD_SHOTCLASSTXT" />,
      path: `${contentBulkUpload.path(tenantName)}/shotclassDetails`,
      icon: (fill) => <DetailsIcon fill={fill} />,
      color: colors.green,
      onClick: () =>
        navigate(`${contentBulkUpload.path(tenantName)}/shotclassDetails`),
      sampleLink: ShotClass,
      fileType: 6,
    },
    {
      key: 2,
      label: <FormattedMessage id="BULKUPLD_QUESTXT" />,
      path: `${contentBulkUpload.path(tenantName)}/questionsAndChoices`,
      icon: (fill) => <QuestionsAndChoicesIcon fill={fill} />,
      color: colors.purple,
      onClick: () =>
        navigate(`${contentBulkUpload.path(tenantName)}/questionsAndChoices`),
      sampleLink: Questionaire,
      fileType: 5,
    },
    {
      key: 3,
      label: <FormattedMessage id="BULKUPLD_QUESBANK" />,
      path: `${contentBulkUpload.path(tenantName)}/questionBank`,
      icon: (fill) => <QuestionBankIcon fill={fill} />,
      color: colors.darkGreen,
      onClick: () =>
        navigate(`${contentBulkUpload.path(tenantName)}/questionBank`),
      sampleLink: ShotclassesQuestionBank,
      fileType: 17,
    },
    {
      key: 4,
      label: <FormattedMessage id="BULKUPLD_DLYDGST" />,
      path: `${contentBulkUpload.path(tenantName)}/dailyDigest`,
      color: colors.orange,
      icon: (fill) => <DailyDigestIcon fill={fill} />,
      onClick: () =>
        navigate(`${contentBulkUpload.path(tenantName)}/dailyDigest`),
      sampleLink: ShotclassesDailyDigest,
      fileType: 18,
    },
    {
      key: 5,
      label: "Quiz Images",
      path: `${contentBulkUpload.path(tenantName)}/quizImages`,
      color: colors.blue,
      icon: (fill) => <QuizImagesIcon fill={fill} />,
      onClick: () =>
        navigate(`${contentBulkUpload.path(tenantName)}/quizImages`),
      sampleLink: "",
      fileType: 0,
    },
  ],
};
